import AuthService from '../../utilities/services/auth.service'
import { FnbAnalyticsWrapper } from '../../components'

export default function FnbAnalyticsPage() {
  const organization = AuthService.getOrg()[0]

  return <FnbAnalyticsWrapper organization={organization} />
}
